import { checkJsonResult } from './util';

export const analyzePhoto = (serverId, type) => fetch(
  `/api/photos/${type}/wechat`,
  {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: serverId,
    }),
    credentials: 'same-origin',
  },
).then(checkJsonResult);



// WEBPACK FOOTER //
// ./src/api/photo.js